import { render } from "./Faculity-Members-Details.vue?vue&type=template&id=34e87669&scoped=true"
import script from "./Faculity-Members-Details.vue?vue&type=script&lang=js"
export * from "./Faculity-Members-Details.vue?vue&type=script&lang=js"

import "./Faculity-Members-Details.vue?vue&type=style&index=0&id=34e87669&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-34e87669"

export default script